import Loadable from 'react-loadable';

export const PhotoSessionDetailLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "photoSessionDetail" */ './index'),
  loading: () => null,
});
